/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Field } from 'react-final-form';

import { BlendBridge } from 'blb-types/blendBridge';
import {
  additionalLineTextInputConfig,
  cityInputConfig,
  countyInputConfig,
  getNameInputConfig,
  lineTextInputConfig,
  stateInputConfig,
  zipcodeInputConfig,
} from 'blb-inputs/common';

import { FormColumnWrapper } from '../styles';

interface TeamInfoFormProps {
  teamInfo?: BlendBridge.API.PatchGroupBody;
}
const TeamInfoForm: React.FC<TeamInfoFormProps> = ({ teamInfo }) => (
  <>
    <Field {...getNameInputConfig('team')} initialValue={teamInfo?.name} name="name" />
    <Field
      {...lineTextInputConfig}
      initialValue={teamInfo?.addressLineOne}
      label="Business street address"
      name="addressLineOne"
    />
    <Field {...additionalLineTextInputConfig} initialValue={teamInfo?.addressLineTwo} name="addressLineTwo" />
    <FormColumnWrapper>
      <Field {...cityInputConfig} initialValue={teamInfo?.city} />
      <Field {...countyInputConfig} initialValue={teamInfo?.county} />
    </FormColumnWrapper>
    <FormColumnWrapper>
      <Field {...stateInputConfig} initialValue={teamInfo?.state} />
      <Field {...zipcodeInputConfig} initialValue={teamInfo?.zipcode} />
    </FormColumnWrapper>
  </>
);

export default TeamInfoForm;
